export const IGNORE_ERROR_PATTERNS = [
  /^NotFoundError: Failed to execute 'insertBefore'/,
];
